import { render, staticRenderFns } from "./kllk-form-warp.vue?vue&type=template&id=c186bade&scoped=true"
import script from "./kllk-form-warp.vue?vue&type=script&lang=js"
export * from "./kllk-form-warp.vue?vue&type=script&lang=js"
import style0 from "./kllk-form-warp.vue?vue&type=style&index=0&id=c186bade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c186bade",
  null
  
)

export default component.exports